import SectionHeading from "@/components/ui/SectionHeading";

export default function PageIntro({
  eyebrow,
  title,
  description,
  titleAs,
  fullWidth,
  className,
  titleClassName,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  titleAs?: "h1" | "h2";
  fullWidth?: boolean;
  className?: string;
  titleClassName?: string;
}) {
  return (
    <SectionHeading
      eyebrow={eyebrow}
      title={title}
      description={description}
      titleAs={titleAs}
      fullWidth={fullWidth}
      className={className}
      titleClassName={titleClassName}
    />
  );
}
